module.exports = __webpack_public_path__ + "static/media/file-txt.cdc57e93.svg";